import { useT } from '@transifex/react'
import { useHasOutdatedTaxCategory } from '../hook/useHasOutdatedTaxCategory'
import { LineItem } from '../../../../../models/line-item'

const WARNING_CONTEXT =
  'Sale Line Item Expanded > Fulfillment > Outdated Tax Category'

export interface OutdatedTaxCategoryWarningProps {
  lineItem: LineItem
}

export const useOutdatedTaxCategoryWarningModel = ({
  lineItem,
}: OutdatedTaxCategoryWarningProps) => {
  const t = useT()
  const isOutdated = useHasOutdatedTaxCategory(
    lineItem?.id || lineItem?.localId
  )

  if (!isOutdated) {
    return {
      isOutdated,
    }
  }

  const productId = lineItem.product?.variant_parent_id || lineItem.product?.id

  return {
    isOutdated,
    href: `/product/${productId}/update`,
    linkText: t('Update category', {
      _key: 'sale.line-item-expanded.fulfilment.update-category-link',
      _context: WARNING_CONTEXT,
    }),
    message: t('Outdated tax category may affect tax calculations.', {
      _key: 'sale.line-item-expanded.fulfilment.outdated-tax-category',
      _context: WARNING_CONTEXT,
    }),
  }
}
